import { createComponentStore } from './createComponentStore';

export const useViewProcedureStageComponentStore = createComponentStore('viewProcedureStageComponent');
